import { Navigate, useLocation } from "react-router-dom";
import useUserStore from "../store/userStore";
import Layout from "./Layout";
import { useEffect } from "react";
import useTokenLogin from "../hooks/useTokenLogin";

const PrivateRoute = () => {
    var token = useUserStore((state) => state.token);
    const setToken = useUserStore((state) => state.setToken);
    const setDestinyRoute = useUserStore((state) => state.setDestinyRoute);
    const location = useLocation();

    const { mutate, isPending } = useTokenLogin();

    useEffect(() => {
        if (!token) {
            const localToken = localStorage.getItem("token");
            if (localToken) {
                mutate(localToken, {
                    onSuccess: (data) => {
                        setToken(data);
                        token = data.token;
                    },
                    onError: () => {
                        localStorage.removeItem("token");
                    },
                });
            }
        }
    }, [token, mutate, setToken]);

    if (isPending) return <>Loading...</>;
    if (token === "") {
        setDestinyRoute(location.pathname);
        return <Navigate to="/login" />;
    } else {
        return <Layout />;
    }
};

export default PrivateRoute;
